export const DEFAULT_MAP_CENTER = { lat: 49.25363726536889, lng: -123.1114298669681 };
export const DEFAULT_MAP_ZOOM = 13;
export const TRAVEL_MODES = ['DRIVE', 'TWO_WHEELER'];
export const SPEED_COLORS = {
  SLOW: '#f44236', // Red
  NORMAL: '#0e53ff', // Blue
  TRAFFIC_JAM: '#f44236', // Orange
};
